export default __webpack_public_path__ + "media/color/fsn-1f81e27a.svg";